import { fetchRequisitionDetailsById } from '@store/actions';

interface CollatedReport {
  description?: string;
  uri?: string;
}

interface RequisitionDownloadPayload {
  collated_report?: CollatedReport | null;
}

const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

/** Absent unless LIMS generated a collated report file, which order status does not tell us. */
export const fetchCollatedReport = async (
  requisitionId: string,
  options?: { suppressErrorToast?: boolean },
): Promise<CollatedReport | null> => {
  const details = (
    options?.suppressErrorToast
      ? await fetchRequisitionDetailsById(requisitionId, { suppressErrorToast: true })
      : await fetchRequisitionDetailsById(requisitionId)
  ) as RequisitionDownloadPayload;
  return details.collated_report?.uri ? details.collated_report : null;
};

export const downloadCollatedReport = async (requisitionId: string): Promise<void> => {
  // Re-fetched on click rather than cached: `uri` is a presigned URL that expires.
  const report = await fetchCollatedReport(requisitionId);

  if (!report?.uri) {
    throw new Error(`No collated report for ${requisitionId}`);
  }

  const link = document.createElement('a');
  link.download = report.description ?? '';
  link.href = report.uri;
  link.type = 'application/pdf';
  if (!MOBILE_USER_AGENT.test(navigator.userAgent)) link.target = '_blank';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
